import { Moon, Sun } from 'lucide-react'

const DarkModeToggle = ({ isDarkMode, toggleDarkMode }) => {
    return (
        <button
            onClick={toggleDarkMode}
            className="relative inline-flex items-center w-14 h-8 rounded-full bg-gray-300 dark:bg-gray-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900"
            aria-label="Toggle dark mode">
            {/* Toggle Thumb */}
            <span
                className={`absolute top-1 left-1 w-6 h-6 bg-white dark:bg-gray-100 rounded-full shadow-md transform transition-transform duration-300 ${
                    isDarkMode ? 'translate-x-6' : 'translate-x-0'
                }`}
            />

            {/* Sun Icon (Light Mode) */}
            <Sun
                className={`absolute left-1.5 w-4 h-4 text-yellow-500 transition-opacity duration-300 ${
                    isDarkMode ? 'opacity-0' : 'opacity-100'
                }`}
            />

            {/* Moon Icon (Dark Mode) */}
            <Moon
                className={`absolute right-1.5 w-4 h-4 text-blue-400 transition-opacity duration-300 ${
                    isDarkMode ? 'opacity-100' : 'opacity-0'
                }`}
            />
        </button>
    )
}

export default DarkModeToggle
